import { CART_PRODUCT_MODEL_CLASS_NAME } from 'models/daos/cart-product/constants'

const CART_MODEL_CLASS_NAME = 'Cart'

const CART_MODEL_KEY = {
  ID: 'id',
  CLASS_NAME: 'className',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  CART_PRODUCTS: 'cartProducts',
  USER: 'user',
  // Foreign keys
  USER_ID: 'userId'
}

const CART_MODEL_KEY_POINTER = CART_MODEL_KEY.USER_ID

/**
 * A mapping of property key to className.
 * @type {Object}
 */
const CART_MODEL_ASSOCIATION = {
  [CART_MODEL_KEY.CART_PRODUCTS]: CART_PRODUCT_MODEL_CLASS_NAME
}

export {
  CART_MODEL_CLASS_NAME,
  CART_MODEL_KEY_POINTER,
  CART_MODEL_ASSOCIATION
}
